import { Injectable } from "@angular/core";
import { DmsRestService } from "@sharedcommon/rest/dms/dms.restservice";
import saveAs from "file-saver";
import { SampleDto } from "@sharedcommon/model/sample/sample.model";
import { SampleRestService } from "@sharedcommon/rest/sample/sample.restservice";
import { EventCreationDto } from "@sharedcommon/model/event-creation.model";
import { FunctionUtils } from "@sharedcommon/util/functions.util";
import moment from "moment";
import { Observable } from "rxjs";

@Injectable()
export class DmsAndSampleService {
  static readonly DOWNLOAD_EVENT_TYPE: string = "Open bulletin from MatrixNutri";

  constructor(private readonly dmsService: DmsRestService, private readonly sampleRestService: SampleRestService){}

  /**
   * Download the doc with the right name and create event
   *
   * @param documentId     the ID of the document to download
   * @param sample         the sample from what the document is
   * @param referenceLabel the label of the reference linked to the sample
   */
  downloadDocumentAndCreateEvent(documentId: string, sample: SampleDto, referenceLabel: string): Observable<void> {
    return new Observable<void>(observer => {
      this.dmsService.getDocument(documentId)
      .subscribe({
        next : response => {
          const blob = new Blob([response], {type: 'application/pdf'})
          saveAs(blob, DmsAndSampleService.returnBulletinName(sample, referenceLabel));
          observer.next();
          observer.complete();
          this.createDownloadDocEvent(sample.id, true);
        },
        error :(error: any) => {
          observer.next();
          observer.complete();
          this.createDownloadDocEvent(sample.id, false);
          // Rethrow the error to get the build-in popin
          throw error;
        }
      });
    })
  }

  /**
   * launch the event creation of the sample for download of document
   *
   * @param sampleId the sample ID from what the document is downloaded
   * @param success  at true if the download process is a successful one
   */
  private createDownloadDocEvent(sampleId: string, success: boolean) {
    this.sampleRestService.createEventForSampleId(
      sampleId, new EventCreationDto(DmsAndSampleService.DOWNLOAD_EVENT_TYPE, success)
    ).subscribe();
  }

  /**
   * Get the bulletin name after download it. It removes all possible forbidden character from the name
   * which is not handled by windows operating system
   *
   * @param sample         the sample linked to the bulletin
   * @param referenceLabel the label of the reference linked to the sample
   * @returns the bulletin name
   */
  private static returnBulletinName(sample: SampleDto, referenceLabel: string): string {
    const validationDateMoment = sample?.validationDate ? moment(new Date(sample.validationDate)) : null;
    const fileName = `${sample.farm?.label ?? ''}_${referenceLabel}_${validationDateMoment?.format("YYYYMMDD") ?? ''}_${sample.code}_v${sample.version}.pdf`
    return FunctionUtils.removeForbiddenCharacterForFile(fileName, '_');
  }

}
